import React from "react";
import { useParams } from "react-router-dom";
import { Row, Col } from "antd";

import useMapData from "../../utils/useMapData";

import FloorPlanCard from "../SitePlan/FloorPlanCard";
import { VerticalText } from "../../StyledCmp";

const SitePlan = React.forwardRef((props, ref) => {
  const { propertyId } = useParams();
  const resultList = useMapData(propertyId);

  return (
    <Row className="site_map_wrapper" ref={ref}>
      <div id="horizontal_text">
        <h1 style={{ color: resultList?.themeColor }}>Site & Floor Plan</h1>
      </div>
      <Col lg={8}>
        <h1>Master Plan</h1>
        <FloorPlanCard
          key={`${resultList?.masterPlan}`}
          floorPlanType="master"
          masterFloorPlanImage={resultList?.masterPlan}
        />
      </Col>
      <Col lg={13}>
        <h1>Floor Plan</h1>
        <div className="floor_wrapper">
          {resultList?.sitePlanDetails?.map((plan, index) => {
            return (
              <FloorPlanCard
                key={plan.title}
                floorPlanType="floor"
                floorPlanImage={plan.imageUrl}
                floorText={plan.title}
              />
            );
          })}
        </div>
      </Col>
      <Col lg={1}>
        <div className="vertical_text">
          <VerticalText>Site & Floor Plan</VerticalText>
        </div>
      </Col>
    </Row>
  );
});

export default SitePlan;
